<template>
    <div id="ssoRegister">
        <div class="registerWin">
            <!-- 邮箱 -->
            <input class="registerInput longInput emailInput" type="text" v-model="email" placeholder="邮箱" v-on:blur="checkEmail"> 
            <p class="errTip" v-if="emailErr">{{emailErrTip}}</p>
            <!-- 密码 -->
            <div class="passBox">
                <input class="registerInput longInput" type="password" v-model="password" placeholder="密码" v-if="passType1" v-on:blur="checkConfirmPass"/>
                <input class="registerInput longInput" type="text" v-model="password" placeholder="密码" v-if="!passType1" v-on:blur="checkConfirmPass"/>
                <img class="passEye passEye1" src="./images/open.png" alt="" v-if="passType1" v-on:click="changePassType(1)">
                <img class="passEye passEye1" src="./images/close.png" alt="" v-if="!passType1" v-on:click="changePassType(1)">
            </div>
            <p class="errTip" v-if="passErr">{{passErrTip}}</p>
            <!-- 确认密码 -->
            <div class="passBox">
                <input class="registerInput longInput" type="password" v-model="confPass" placeholder="确认密码" v-if="passType2" v-on:blur="checkConfirmPass"/>
                <input class="registerInput longInput" type="text" v-model="confPass" placeholder="确认密码" v-if="!passType2" v-on:blur="checkConfirmPass"/>
                <img class="passEye passEye2" src="./images/open.png" alt="" v-if="passType2" v-on:click="changePassType(2)">
                <img class="passEye passEye2" src="./images/close.png" alt="" v-if="!passType2" v-on:click="changePassType(2)">
            </div>
            <p class="errTip" v-if="confPassErr">{{confPassErrTip}}</p>
            <!-- 图形验证码 -->
            <input class="registerInput codeInput" type="text" v-model="graphicsCode" placeholder="验证码" maxlength="4" v-on:blur="checkGraphicsCode">
            <div class="graphicsCodeImgText" @click="changImgSrc" >
                <img class="graphicsCodeImg" :src="imgSrc" alt="">
                <span class="graphicsCodeText">看不清？</span>
            </div>
            <p class="errTip" v-if="graphicsCodeErr">{{graphicsCodeErrTip}}</p>
             <!-- 手机号 -->
            <input class="registerInput longInput" type="text" v-model="phone" placeholder="手机号" maxlength="11"> <!-- v-on:blur="checkPhone" -->
            <p class="errTip" v-if="phoneErr">{{phoneErrTip}}</p>
            <!-- 短信验证码 6位 -->
            <input class="registerInput midInput" type="text" v-model="phoneCode" placeholder="短信验证码" maxlength="6" v-on:blur="checkPhoneCode">
            <input type="button" class="codeImg getPhoneCode" v-bind:value="codeTime" v-on:click="getPhoneCode"  v-bind:disabled="noSend">
            <p class="errTip" v-if="phoneCodeErr">{{phoneCodeErrTip}}</p>
            
             <!-- 注册按钮 -->
            <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
            <input class="registerInput longInput confirm" type="button" value="注册" v-on:click="register" v-bind:disabled="noRegister">
            <div class="registerBottom">
                <span>已有账户&nbsp;&nbsp;&nbsp;&nbsp;</span><router-link to="/login" class="toRegister">立即登录</router-link>
            </div>
        </div>
        <popup :title="dialogTitle" v-if="showDialog" :showClose="showClose" :showPopBtn="showPopBtn">

        </popup>
    </div>
</template>
<script>
    import api from 'sso.server';
    import reg from 'reg';
    import aes from 'AES';
    import Popup from 'popup';

    module.exports = Vue.component('sso-register',{
        data:function() {
            return {
                email:'',               // 邮箱
                emailErr:false,         // 邮箱错误
                emailErrTip:null,

                password:'',            // 密码
                passErr:false,          // 密码错误
                passErrTip:null,

                confPass:'',            // 确认密码
                confPassErr:false,      // 确认密码错误
                confPassErrTip:null,

                passType1:true,
                passType2:true,

                // 图形验证码
                // imgSrc:  'http://192.168.201.72:8080'+ window.PAGE_DATA.commonData.imgPhoneSrc,
                imgSrc:  window.PAGE_DATA.commonData.basePath + window.PAGE_DATA.commonData.imgPhoneSrc,
                graphicsCode:'',
                graphicsCodeErr:false,     //图形验证码错误
                graphicsCodeErrTip:null,

                phone:'',               // 手机号
                phoneErr:false,         // 手机号错误
                phoneErrTip:null,
                isCheckPhone: false,    // 检测手机号,如果通过是true,否则false

                phoneCode:'',           // 短信验证码
                phoneCodeErr:false,     // 短信验证码错误
                phoneCodeErrTip:null,

                codeTime:'发送验证码',  // 获取验证码按钮文本

                msgErr:false,           // 后台错误提示
                msgErrTip:null,

                noSend:false,           // 禁止发送验证
                noRegister:false,       // 禁止重复提交

                dialogTitle:"注册成功",   // 注册成功之后的提示
                showDialog:false,        // 注册之后提示窗口
                showPopBtn:false,
                showClose:false,
            }
        },
        mounted:function(){
            let _this = this;
            window.onkeyup = function(item){
                if (item.keyCode == 13) {
                    _this.register();
                }
            }
        },
        methods:{
            // 密码显示隐藏切换
            changePassType:function(num){
                let type = 'passType'+num;
                this[type] = !this[type];
            },
            changImgSrc:function(){
                this.imgSrc =  this.imgSrc + "?" + new Date().getTime(); 
            },
            checkGraphicsCode:function(){
                if (this.graphicsCode.length == 0) {
                    this.graphicsCodeErr = true;
                    this.graphicsCodeErrTip = "图形验证码不能为空";
                } else if (!reg.graphicsCode(this.graphicsCode)) {
                    this.graphicsCodeErr = true;
                    this.graphicsCodeErrTip = "图形验证码格式不正确";
                } else {
                    this.graphicsCodeErr = false;
                    this.graphicsCodeErrTip = "";
                }
                this.msgErr = false;
            },
            checkPhoneCode:function(){
                if (this.phoneCode.length == 0) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码不能为空";
                } else if (!reg.phoneCode(this.phoneCode)) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码格式不正确";
                } else {
                    this.phoneCodeErr = false;
                    this.phoneCodeErrTip = "";
                }
                this.msgErr = false;
            },
            // 注册按钮
            register:function(){
                 if (!this.emailErr && !this.phoneErr && !this.phoneCodeErr && !this.passErr && !this.confPassErr && !this.graphicsCodeErr) {
                    if(this.email.length == 0){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                        this.msgErr = false;
                    } else if(this.password.length == 0){
                        this.passErr = true;
                        this.passErrTip = '密码不能为空';
                    } else if(this.confPass.length == 0){
                        this.confPassErr = true;
                        this.confPassErrTip = '确认密码不能为空';
                    }else if(this.graphicsCode.length == 0){
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = "图形验证码不能为空";
                    } else if(this.phone.length == 0){
                        this.msgErr = false;
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                    } else if(this.phoneCode.length == 0){
                        this.msgErr = false;
                        this.phoneCodeErr = true;
                        this.phoneCodeErrTip = '验证码不能为空';
                    } else{
                        this.noRegister = true;
                        let _this = this;
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let param = {
                            password:aes.getAes(this.password, timer),
                            phone:aes.getAes(this.phone, timer),
                            email:aes.getAes(this.email, timer),
                            phoneCode:this.phoneCode,
                            valdaiteCode :this.graphicsCode,
                            timer:timer
                        };
                        api.register(param)
                        .then(function(res){
                            if(res.data.header && res.data.header.code == 200){
                                _this.showDialog = true;
                                setTimeout(function(){
                                    _this.showDialog = false;
                                    _this.$router.push({
                                    path:'/login'
                                })
                                }, 1000);

                            } else {
                                _this.changImgSrc()
                                _this.noRegister = false;
                                _this.resErorMsg(res.data.header.code, res.data.header.msg)
                                _this.phoneCode = "";
                            }
                        },function(res){
                            _this.noRegister = false;
                            _this.msgErr = true;
                            _this.msgErrTip = '网络异常';
                        })
                    }
                }

            },
            // 检测电话,邮件输入内容是否
            webCheck:function(type){
                let state;
                if(type=="phone"){
                    if(this.phone.length == 0){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                        state = false;
                    }else if(!reg.validPhone(this.phone)){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号格式不正确';
                        state = false;
                    }else{
                        state = true;
                    }
                }else if(type=="email"){
                    if(this.email.length == 0){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                        state = false;
                    }else if(!reg.validEmail(this.email)){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱格式不正确';
                        state = false;
                    }else{
                        this.emailErr = false;
                        this.emailErrTip = '';
                        state = true;
                    }
                }
                return state;
            },
            checkEmail:function(){
                let state = this.webCheck('email');
                // if(!state){
                //    return;
                // }else{
                //     let _this = this;
                //     let param = {
                //         email: this.email
                //     }
                //     // 检测邮箱是否符合规范,符合要求
                //     api.checkEmail(param)
                //     .then(function(res){
                //         if(res.data.header && (res.data.header.code == 200)){
                //             _this.emailErr = false;
                //         }else{
                //             _this.emailErr = true;
                //             _this.emailErrTip = res.data.header.msg;
                //         }
                //     },function(res){
                //         _this.emailErr = true;
                //         _this.emailErrTip = '网络异常';
                //     })
                // }
            },
            // 检测两次密码是否一致
            checkConfirmPass: function(){
                if(!this.confPass){
                    this.confPassErr = true;
                    this.confPassErrTip = '确认密码不能为空';
                }else if(this.confPass != this.password){
                    this.confPassErr = true;
                    this.confPassErrTip = '两次密码不一致';
                }else{
                    this.confPassErr = false;
                }
            },
            // 检测电话号码是否可用,是否重复使用
            checkPhone:function(){
                let state = this.webCheck('phone');
                // if (!state){
                //     return;
                // }else {
                //     let _this = this;
                //     let getPhone = {
                //         phone: this.phone
                //     }
                //     api.checkPhone(getPhone)
                //     .then(function(res){
                //         if(res.data.header && (res.data.header.code == 200)){
                //             _this.phoneErr = false;
                //             _this.isCheckPhone = true;
                //         }else{
                //            _this.phoneErr = true;
                //            _this.phoneErrTip = res.data.header.msg;
                //         }
                //     },function(res){
                //         _this.phoneErr = true;
                //         _this.phoneErrTip = "网络异常";
                //     })
                // }
            },
            // 获取短信验证码
            getPhoneCode:function(){
                // 先检测电话号码格式是否通过,通过去检测重复使用
                // let state = this.webCheck('phone');
                 if (!this.emailErr && !this.phoneErr && !this.passErr && !this.confPassErr && !this.graphicsCodeErr) {
                    if(this.email.length == 0){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                        this.msgErr = false;
                    } else if(this.password.length == 0){
                        this.passErr = true;
                        this.passErrTip = '密码不能为空';
                    } else if(this.confPass.length == 0){
                        this.confPassErr = true;
                        this.confPassErrTip = '确认密码不能为空';
                    }else if(this.graphicsCode.length == 0){
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = "图形验证码不能为空";
                    } else if(this.phone.length == 0){
                        this.msgErr = false;
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                    } else{
                        let _this = this;
                        _this.noSend = true;  // 验证手机号期间禁止重复验证
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let param = {
                            email:aes.getAes(this.email, timer),
                            phone:aes.getAes(this.phone, timer),
                            password:aes.getAes(this.password, timer),
                            timer:timer,
                            valdaiteCode: this.graphicsCode
                        }
                        this.phoneCodeErr = false;
                        this.phoneCodeErrTip = '';
                        _this.isCheckPhone = false
                        api.sendPhoneCodeRegister(param)
                        .then(function(res){
                            
                            // 手机号验证成功，开始倒计时
                            if (res.data.header && (res.data.header.code == 200)) {
                                _this.phoneCodeErr = false;
                                let time = 60;
                                _this.codeTime = '60S';
                                _this.isCheckPhone = true
                                let timer = setInterval(function(){
                                    if(time != 1){
                                        time--;
                                        _this.codeTime = time + 'S';
                                    }else{
                                        _this.codeTime = '重新发送';
                                        _this.noSend = false;       // 倒计时结束，放开获取验证码按钮
                                        clearInterval(timer);
                                    }
                                },1000);
                            }else {
                                _this.noSend = false; 
                                _this.resErorMsg(res.data.header.code, res.data.header.msg)
                                // _this.changImgSrc()
                            }

                        },function(res){
                            _this.noSend = false;  
                            _this.msgErr = true;
                            _this.msgErrTip = "网络异常";
                        })
                        
                    }
                }

            },
            // 提示框文本的隐藏
            popConfirm: function(){
                this.showDialog = false;
            },
            resErorMsg(code, msg){
                 code = Number(code)
                switch (code) {
                    case 40022: // 邮箱已被使用
                        this.emailErr = true;
                        this.emailErrTip = msg;
                        break;
                    case 40013: // 手机号已被使用
                        this.phoneErr = true;
                        this.phoneErrTip = msg;
                        break;
                    case 40046: // 图片验证码不正确
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = msg;
                        break;
                    case 40047: //图片验证码已失效
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = msg;
                        break;
                    case 40016: //短信验证码不正确
                        this.phoneCodeErr = true;
                        this.phoneCodeErrTip = msg;
                        break; 
                    default:
                        this.msgErr = true;
                        this.msgErrTip = msg;
                        break;
                }
            }   
        },
        watch:{
            'email':{
                'handler':function(val){
                    if(!val){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                    }else if(!reg.validEmail(val)){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱格式不正确';
                    }else{
                        this.emailErr = false;
                    }
                }
            },
            'phone':{
                'handler':function(val){
                    if(!val){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                    }else if(!reg.validPhone(val)){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号格式不正确';
                    }else{
                        this.phoneErr = false;
                    }
                }
            },
            'password':{
                'handler':function(val){
                    if(!val){
                        this.passErr = true;
                        this.passErrTip = '密码不能为空';
                    }else if(!reg.validPassword(val)){
                        this.passErr = true;
                        this.passErrTip = '6-16位数字字母组成';
                    }else{
                        this.passErr = false;
                        if (val === this.confPass) {
                            this.confPassErr = false;
                        }
                    }
                }
            },
            'confPass':{
                'handler':function(val) {
                    if(!val){
                        this.confPassErr = true;
                        this.confPassErrTip = '确认密码不能为空';
                    }else if(val != this.password){
                        this.confPassErr = true;
                        this.confPassErrTip = '两次密码不一致';
                    }else{
                        this.confPassErr = false;
                    }
                }
            },
            'graphicsCode':{
                'handler':function(val) {
                    if (!val) {
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = "图形验证码不能为空";
                    } else if (!reg.graphicsCode(val)) {
                        this.graphicsCodeErr = true;
                        this.graphicsCodeErrTip = "图形验证码格式不正确";
                    } else {
                        this.graphicsCodeErr = false;
                        this.graphicsCodeErrTip = "";
                    }
                }
            },
        }
    })
</script>
<style lang="scss" scoped>
    #ssoRegister{
        width: 284px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 7px;
        .registerWin{
            .registerInput{
                height:42px;
                background-color: #fff;
                border:none;
                border-radius:6px;
                padding-left:10px;
                font-size:16px;
                color:#666;
                margin-top:12px;
                margin-bottom: 7px;
                &.emailInput{
                    margin-top:0;
                }
            }
            .longInput{
                width:100%;
            }
            .midInput{
                width:180px;
            }
            .codeInput{
                width: 130px;
            }
            .passBox{
                position:relative;
                .passEye{
                    position:absolute;
                    width: 17px;
                    height: 17px;
                    right:22px;
                    top: 24.5px;
                    cursor:pointer;
                }
            }
            .graphicsCodeImgText{
                width:140px;
                height:42px;
                // display: inline-block;
                float: right;
                margin-top:11px;
                margin-bottom: 7px;
                cursor: pointer;
                .graphicsCodeImg{
                    display: inline-block;
                    width: 80px;
                    height: 42px;
                    background: #999;
                    border-radius:6px;
                    vertical-align: middle;
                }
                .graphicsCodeText{
                    display: inline-block;
                    height: 42px;
                    line-height: 42px;
                    padding-left: 5px;
                    font-size: 10px;
                    &:hover{
                        color: darkblue;
                    }
                }
            }
            
            .codeImg{
                width:90px;
                height:42px;
                float:right;
                margin-top:12px;
                margin-bottom: 7px;
                border-radius:6px;
                cursor:pointer;
                &.getPhoneCode{
                    display:inline-block;
                    border:none;
                    background-color: #364983;
                    font-size:12px;
                    color:#fff;
                    text-align:center;
                    line-height:42px;
                    &:hover{
                        background: #435898;
                    }
                }
            }
            .confirm{
                background-color: #364983;
                color:#fff;
                font-size:18px;
                cursor:pointer;
                margin-top: 12px;
                margin-bottom: 0px;
                &:hover{
                    background: #435898;
                }
            }
            .errTip{
                font-size:12px;
                line-height:18px;
                color:#CE2E2E;
                padding-left:10px;
                &.msgErrTip{
                    line-height:22px;
                }
            }
            .registerBottom{
                margin-top: 23px;
                border-top: 1px solid #CACACA;
                text-align: center;
                padding-top: 10px;
                padding-bottom: 18px;
                span{
                    font-size: 14px;
                    color: #666666;
                }
                a{
                    color:#364983;
                    margin-top: 10px;
                    font-size: 18px;
                    &:hover{
                        color: #435898;
                    }
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/sso/components/register/register.vue